import React, { useState } from 'react';
import { ENTITLEMENT_OPTIONS, EMPTY_PERK, normalizePerk, parseEntitlements } from '../utils/entitlements';

function PerksEditor({ perks, onChange, idPrefix = 'perk' }) {
  const [draft, setDraft] = useState({ ...EMPTY_PERK });

  const list = parseEntitlements(perks || []);

  const handleDraftChange = (e) => {
    const { name, value } = e.target;
    setDraft((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const next = normalizePerk(draft);
    if (!next || !next.title.trim()) return;
    onChange([...list, next]);
    setDraft({ ...EMPTY_PERK });
  };

  const handleRemove = (index) => {
    onChange(list.filter((_, i) => i !== index));
  };

  return (
    <div className="perks-editor">
      <div className="section-header" style={{ marginBottom: 8 }}>
        <label style={{ margin: 0 }}>Perks</label>
      </div>

      {list.length === 0 ? (
        <p className="subtitle">No perks yet. Add a title, category, and description below.</p>
      ) : (
        <ul className="perks-list">
          {list.map((perk, index) => (
            <li key={`${perk.title}-${perk.category}-${index}`} className="perk-item">
              <div className="perk-item-body">
                <strong>{perk.title}</strong>
                {perk.category ? (
                  <span className="perk-category">{perk.category}</span>
                ) : null}
                {perk.description ? <p className="subtitle">{perk.description}</p> : null}
              </div>
              <button
                type="button"
                className="btn-table"
                onClick={() => handleRemove(index)}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}

      <div className="perk-add-form">
        <div className="form-group">
          <label htmlFor={`${idPrefix}-title`}>Title *</label>
          <input
            id={`${idPrefix}-title`}
            name="title"
            value={draft.title}
            onChange={handleDraftChange}
            placeholder="e.g. Preferred Parking"
          />
        </div>
        <div className="form-group">
          <label htmlFor={`${idPrefix}-category`}>Category *</label>
          <select
            id={`${idPrefix}-category`}
            name="category"
            value={draft.category}
            onChange={handleDraftChange}
          >
            {ENTITLEMENT_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor={`${idPrefix}-description`}>Description</label>
          <textarea
            id={`${idPrefix}-description`}
            name="description"
            value={draft.description}
            onChange={handleDraftChange}
            rows={2}
            placeholder="Short details for this perk"
          />
        </div>
        <button type="button" className="btn-secondary" onClick={handleAdd}>
          + Add perk
        </button>
      </div>
    </div>
  );
}

export default PerksEditor;
